import { AnySchema } from 'ajv';

import { FieldErrorMessage } from '../../../../models/FieldErrorMessage';
import { validateFormData } from '../../../../utils/validations/validateFormData';
import { ICreateDOCOrganizationSubscriptionExtensionModel } from '../../../../models/interfaces/Subscription/DutyOfCare/CreateDOCOrganizationSubscriptionExtensionModel';

const schema: AnySchema | any = {
  type: 'object',
  properties: {},
  dependencies: {},
  required: [],
};

export const validateExtendDOCSubscriptionForm = (
  data: ICreateDOCOrganizationSubscriptionExtensionModel,
  additionalErrors?: FieldErrorMessage[],
) => validateFormData(data, additionalErrors, schema);
